import { Injectable } from '@angular/core';
import { SmartDatePipe } from 'src/app/pipes/smart-date.pipe';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor(private smartDate: SmartDatePipe, private localStorageService: LocalStorageService) {}

  serializeToGetParams(object): string {
    let str = '';
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (encodeURIComponent(object[key])) {
          if (str !== '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(object[key]);
        }
      }
    }
    return str;
  }

  generateLegNo(
    flight_id?: string,
    flight_datetime?: string,
    source?: string,
    dest?: string
  ) {
    flight_id = flight_id.toLowerCase();
    let legNo =
      flight_id +
      '-' +
      Date.parse(this.smartDate.normalizeFormat(flight_datetime)) / 1000;
    if (source) {
      source = source.toLowerCase();
      legNo += '-' + source;
    }
    if (dest) {
      dest = dest.toLowerCase();
      legNo += '-' + dest;
    }
    return legNo;
  }

  parseLegNo(legNo: string) {
    const arr = legNo.split('-');
    let source = '';
    let dest = '';

    const flightId = arr[0].toUpperCase();
    if (arr[2]) {
      source = arr[2].toUpperCase();
    }
    if (arr[3]) {
      dest = arr[3].toUpperCase();
    }

    const date = new Date(parseInt(arr[1]) * 1000);
    const ondate =
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();

    let data = {
      flightId: flightId,
      source: source,
      dest: dest,
      ondate: ondate,
    };

    return data;
  }

  calculateTravelDuration(departureTime: any, arrivalTime: any) {
    const departureDateTime = new Date(departureTime);
    const arrivalDateTime = new Date(arrivalTime);

    const timeDifference =
      arrivalDateTime.getTime() - departureDateTime.getTime();
    const hours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    return [hours, minutes];
  }

  convertToLocalTimezoneDate(utcDate: any) {
    const date = new Date(utcDate.replace(/ /g, 'T'));
    const localTimezoneDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );
    return localTimezoneDate;
  }

  validateDate(inputDate: any, offset?: number) {
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) {
      return false;
    }
    const currentDate = new Date();
    if (offset) {
      currentDate.setDate(currentDate.getDate() + offset);
    }
    currentDate.setHours(0, 0, 0, 0);
    if (date < currentDate) {
      return false;
    }
    return true;
  }

  isHotelDealRoute(){
    let searchQuery: any = this.localStorageService.getItem(localStorageKeys.HOTEL_DEAL_SEARCH_QUERY);
    if(searchQuery){
      searchQuery = JSON.parse(searchQuery);
      if(searchQuery?.searchType && searchQuery?.searchType === 'deals'){
        return true;
      }
    }
    return false;
  }
}
